import api from "../../../Api";
import {getAppSessionCookieHeader, handleSessionId} from "../appCookie";
import {getSessionUser} from "./WebApi";

export const getInventoryMemberships = async () => {
  return await api.get('cx/inventory/memberships' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryGiftCards = async () => {
  return await api.get('cx/inventory/giftCards' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getClientWaiver = async (waiverGuid) => {
  const resp = await api.get('cx/waiver/download/' + waiverGuid + getAppSessionCookieHeader(),
    {
      responseType: 'blob',
    }).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyInventoryGiftCards = async () => {
  return await api.get('cx/my/giftCards' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getAssignedWaivers = async (ref) => {
  const resp = await api.get('cx/waivers/assigned')
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getMyWaivers = async () => {
  const resp = await api.get('cx/waivers/my')
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getCalendarInventoryEvents = async (req, inventoryRender) => {
  const resp = await api.post('cx/calendar/view/events' + getAppSessionCookieHeader(), req).then((response) => {
    let _resp = {inventoryRender: inventoryRender, events: response.data.events, timeBlocks: response.data.timeBlocks}
    return _resp;
  });
  return resp;
}

export const getPortalInventoryEvents = async (req, inventoryRender) => {
  const resp = await api.post('cx/calendar/events' + getAppSessionCookieHeader(), req).then((response) => {
    let _resp = {inventoryRender: inventoryRender, events: response.data.events, timeBlocks: response.data.timeBlocks}
    return _resp;
  });
  return resp;
}

export const getInventoryEvent = async (guid) => {
  return await api.get('cx/event/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryItem = async (guid) => {
  return await api.get('cx/inventory/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryMembershipsByEvent = async (guid) => {
  return await api.get('cx/inventory/memberships/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const saveGiftCardTransfer = async (giftCard) => {
  return await api.post('cx/giftCard/transfer' + getAppSessionCookieHeader(), giftCard).then((response) => {
    return response.data;
  });
}


export const saveInventoryEventCancellation = async (reservation) => {
  return await api.post('cx/event/cancel' + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  });
}

export const getInventoryEventRegistration = async (eventGuid, customerGuid) => {
  return await api.get('cx/inventory/event/registration/' + eventGuid + '/' + customerGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const createProfile = async (customer) => {
  const resp = await api.post('cx/profile/save' + getAppSessionCookieHeader(), customer).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCartForm = async (form) => {
  return await api.post('cx/form' + getAppSessionCookieHeader(), form).then((response) => {
    return response.data;
  });
}

export const subscribeNewsletter = async (customer) => {
  const resp = await api.post('cx/newsletter/subscribe' + getAppSessionCookieHeader(), customer).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyVisits = async () => {
  const resp = await api.get('cx/visits/my' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getCustomerSales = async () => {
  const resp = await api.get('cx/sales/my' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCustomerInvoices = async () => {
  const resp = await api.get('cx/invoices/my' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCustomerInvoice = async (invoiceGuid) => {
  const resp = await api.get('cx/invoices/my/' + invoiceGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveInventoryEventRegistration = async (reservation, guid) => {
  return await api.post('cx/waitlist/register/' + guid + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  });
}


export const getCustomerIntentSuccess = async (paymentIntent) => {
  const resp = await api.get('cx/sales/intent/' + paymentIntent + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}
export const getInventoryEventWaitlist = async (waitlistGuid, customerGuid) => {
  return await api.get('cx/event/waitlist/' + waitlistGuid + '/' + customerGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getMyCafeOrders = async () => {
  const resp = await api.get('cx/cafe/orders' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getInventory = async () => {
  return await api.get('cx/inventory' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCafeInventory = async () => {
  return await api.get('cx/cafe/inventory' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const removeAttendees = async (req) => {
  return await api.post('cx/cart/attendees/remove' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  });
}

export const updateAttendees = async (cart) => {
  return await api.post('cx/cart/attendees' + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const checkoutTerms = async (cart) => {
  return await api.post('cx/cart/terms' + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const checkoutTip = async (cart) => {
  return await api.post('cx/cart/tip' + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const checkout = async (cart) => {
  return await api.post('cx/cart/checkout' + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
}

export const getCustomerCartFamilyMembers = async () => {
  return await api.get('cx/cart/familyMembers' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCart = async () => {
  return await api.get('cx/cart' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCartLight = async () => {
  return await api.get('cx/cart/light' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCartFull = async (referrer) => {
  let _referrer = referrer ? ('?referrer=' + referrer) : '';
  return await api.get('cx/cart/full' + _referrer + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getAgeRangeTypes = async () => {
  return await api.get('cx/age/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getInventoryEventTypes = async () => {
  return await api.get('cx/event/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const addtoWaitlist = async (inventory) => {
  return await api.post('cx/waitlist' + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}
export const submitPublicWaiver = async (waiver) => {
  const resp = await api.post('cx/waiver/public/submit' + getAppSessionCookieHeader(), waiver).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const submitGuestWaiver = async (waiver) => {
  const resp = await api.post('cx/waiver/guest/submit' + getAppSessionCookieHeader(), waiver).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getPublicEventWaiver = async (guid) => {
  const resp = await api.get('cx/waiver/event/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getPublicWaiver = async (guid) => {
  const resp = await api.get('cx/waiver/public/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const addMembershipReservationToCart = async (inventory) => {
  return await api.post('cx/cart/add/membershipRegistration' + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const removeMemberPerkItem = async (discountItemGuid, item) => {
  return await api.post('cx/cart/perk/remove/' + discountItemGuid + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const updateMemberPerkItem = async (item) => {
  return await api.post('cx/cart/perk/item' + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const addToCart = async (inventory) => {
  return await api.post('cx/cart/add' + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const getCartInvoice = async (guid) => {
  return await api.get('cx/cart/invoice/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCartInvoiceGroup = async (guid, referrer) => {
  let _referrer = referrer ? '?referrer=' + referrer : '';
  return await api.get('cx/cart/invoice/group/' + guid + _referrer + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const saveAssignCartMembershipMembers = async (cartMembers) => {
  return await api.post('cx/cart/membership/update' + getAppSessionCookieHeader(), cartMembers).then((response) => {
    return response.data;
  });
}

export const checkPassResetExpiration = async (tokenGuid) => {
  const resp = await api.get('cx/pass/reset/expiration/' + tokenGuid + getAppSessionCookieHeader()).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const login = async (auth) => {
  const resp = await api.post('cx/login' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const redeemGiftCard = async (req) => {
  const resp = await api.post('cx/gift/card/redeem' + getAppSessionCookieHeader(), req).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const resetPassConfirm = async (auth) => {
  const resp = await api.post('cx/pass/reset/confirm' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const oneTimePassLogin = async (auth) => {
  const resp = await api.post('cx/pass/otp/login' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const resetPass = async (auth) => {
  const resp = await api.post('cx/pass/reset' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const customerSaveClientAccount = async (account) => {
  const resp = await api.post('cx/account' + getAppSessionCookieHeader(), account).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getStates = async () => {
  const resp = await api.get('cx/states' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getReferralTypes = async () => {
  const resp = await api.get('cx/referral/types' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const logout = async () => {
  const resp = await api.post('cx/logout' + getAppSessionCookieHeader()).then((response) => {
    return response;
  });
  return resp;
}

export const saveSpecialRequest = async (request) => {
  const resp = await api.post('cx/reservations/specialRequest' + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveMyProfile = async (customer) => {
  const resp = await api.post('cx/profile/save' + getAppSessionCookieHeader(), customer).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}
export const saveMyCustomerFamily = async (customer) => {
  const resp = await api.post('cx/my/family/save' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyReservations = async () => {
  const resp = await api.get('cx/reservations/my' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyMemberPerks = async () => {
  const resp = await api.get('cx/perks' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyProfile = async () => {
  const resp = await api.get('cx/my/profile' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}
export const deleteMyCustomerFamily = async (familyMember) => {
  return await api.post('cx/my/family/delete/' + familyMember.guid);
}

export const deleteBillingItem = async (billingItem) => {
  return await api.post('cx/my/billing/delete/' + billingItem.guid);
}

export const removeCartItem = async (cartItem) => {
  return await api.post('cx/cart/remove' + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const updateMemberBillingItem = async (cartItem) => {
  return await api.post('cx/cart/billDate' + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

function handleError(error) {
  let err = {
    error: true,
    message: error?.response?.data?.message || JSON.stringify(error)
  }
  return err;
}
